import AdminNavigationConfig from './AdminNavigationConfig';
import MainNavigationConfig from './MainNavigationConfig';
import ThemeConfig from './ThemeConfig';
import {
	AppEnvironment,
	BroadLineOfBusiness
} from '@app/enumerations';
// Import msal module.
import { BrowserCacheLocation } from '@azure/msal-browser';

interface LogoImageSource {
	catCoverageSvgLogo1: string;
	catCoverageSvgLogo2: string;
	ncipSvgLogo: string;
	logo: string;
	logoOnly: string;
}

let mode: string | undefined = process.env.MODE;
let applicationId: string = String.empty();
let applicationScopeUserImpersonation: string = String.empty();
let catcoverageDomain: string = String.empty();
let publicPagesBaseUrl: string = String.empty();
let apiDomain: string = String.empty();
let redirectUri: string = String.empty();
let googleAnalyticsId: string = String.empty();
let enableAuthenticationLogging: boolean = false;
let enableWorkFlowTargetSwitch: boolean = false;

const logoImageSource: LogoImageSource = {
	catCoverageSvgLogo1: '/src/Assets/Images/catcoverage_logo.svg',
	catCoverageSvgLogo2: '/src/Assets/Images/CAT_COVERAGE_logo.svg',
	ncipSvgLogo: '/src/Assets/Images/NCIP_logo_2.svg',
	logoOnly: '/src/Assets/Images/logo_only.png',
	logo: String.empty(),
}

switch (mode) {
	case AppEnvironment.DEMO:
		apiDomain = 'https://demo-app-api.catcoverage.com';
		applicationId = 'b08b01ab-fe0e-460a-8b38-f1c03c75fa88';
		applicationScopeUserImpersonation = 'https://CatCoverage.secureleader.co/catcoverageapplicationdemo/user_impersonation';
		catcoverageDomain = 'https://demo.catcoverage.com';
		enableAuthenticationLogging = true;
		googleAnalyticsId = 'UA-24548396-2';
		logoImageSource.logo = '/src/Assets/Images/logo-demo.png';
		publicPagesBaseUrl = 'https://www.catcoverage.com';
		redirectUri = 'https://demo1-appv2.catcoverage.com/CAT';
		break;
	case AppEnvironment.DEMO2:
		apiDomain = 'https://demo2-app-api.catcoverage.com';
		applicationId = 'b08b01ab-fe0e-460a-8b38-f1c03c75fa88';
		applicationScopeUserImpersonation = 'https://CatCoverage.secureleader.co/catcoverageapplicationdemo/user_impersonation';
		catcoverageDomain = 'https://demo2.catcoverage.com';
		enableAuthenticationLogging = true;
		googleAnalyticsId = 'UA-24548396-2';
		logoImageSource.logo = '/src/Assets/Images/logo-demo.png';
		publicPagesBaseUrl = 'https://www.catcoverage.com';
		redirectUri = 'https://demo2-appv2.catcoverage.com/CAT';
		break;
	case AppEnvironment.DEMO3:
		apiDomain = 'https://demo3-app-api.catcoverage.com';
		applicationId = 'b08b01ab-fe0e-460a-8b38-f1c03c75fa88';
		applicationScopeUserImpersonation = 'https://CatCoverage.secureleader.co/catcoverageapplicationdemo/user_impersonation';
		catcoverageDomain = 'https://demo3.catcoverage.com';
		enableAuthenticationLogging = true;
		googleAnalyticsId = 'UA-24548396-2';
		logoImageSource.logo = '/src/Assets/Images/logo-demo.png';
		publicPagesBaseUrl = 'https://www.catcoverage.com';
		redirectUri = 'https://demo3-appv2.catcoverage.com/CAT';
		break;
	case AppEnvironment.DEMO4:
		apiDomain = 'https://demo4-app-api.catcoverage.com';
		applicationId = 'b08b01ab-fe0e-460a-8b38-f1c03c75fa88';
		applicationScopeUserImpersonation = 'https://CatCoverage.secureleader.co/catcoverageapplicationdemo/user_impersonation';
		catcoverageDomain = 'https://demo4.catcoverage.com';
		enableAuthenticationLogging = true;
		googleAnalyticsId = 'UA-24548396-2';
		logoImageSource.logo = '/src/Assets/Images/logo-demo.png';
		publicPagesBaseUrl = 'https://www.catcoverage.com';
		redirectUri = 'https://demo4-appv2.catcoverage.com/CAT';
		break;
	case AppEnvironment.DEMO5:
		apiDomain = 'https://demo5-app-api.catcoverage.com';
		applicationId = 'b08b01ab-fe0e-460a-8b38-f1c03c75fa88';
		applicationScopeUserImpersonation = 'https://CatCoverage.secureleader.co/catcoverageapplicationdemo/user_impersonation';
		catcoverageDomain = 'https://demo5.catcoverage.com';
		enableAuthenticationLogging = true;
		googleAnalyticsId = 'UA-24548396-2';
		logoImageSource.logo = '/src/Assets/Images/logo-demo.png';
		publicPagesBaseUrl = 'https://www.catcoverage.com';
		redirectUri = 'https://demo5-appv2.catcoverage.com/CAT';
		break;
	case AppEnvironment.DEMO6:
		apiDomain = 'https://demo6-app-api.catcoverage.com';
		applicationId = 'b08b01ab-fe0e-460a-8b38-f1c03c75fa88';
		applicationScopeUserImpersonation = 'https://CatCoverage.secureleader.co/catcoverageapplicationdemo/user_impersonation';
		catcoverageDomain = 'https://demo6.catcoverage.com';
		enableAuthenticationLogging = true;
		googleAnalyticsId = 'UA-24548396-2';
		logoImageSource.logo = '/src/Assets/Images/logo-demo.png';
		publicPagesBaseUrl = 'https://www.catcoverage.com';
		redirectUri = 'https://demo6-appv2.catcoverage.com/CAT';
		break;
	case AppEnvironment.DEVOPS:
		apiDomain = 'https://devops-app-api.catcoverage.com';
		applicationId = 'b08b01ab-fe0e-460a-8b38-f1c03c75fa88';
		applicationScopeUserImpersonation = 'https://CatCoverage.secureleader.co/catcoverageapplicationdemo/user_impersonation';
		catcoverageDomain = 'https://devops.catcoverage.com';
		enableAuthenticationLogging = true;
		googleAnalyticsId = 'UA-24548396-2';
		logoImageSource.logo = '/src/Assets/Images/logo-demo.png';
		publicPagesBaseUrl = 'https://www.catcoverage.com';
		redirectUri = 'https://devops-appv2.catcoverage.com/CAT';
		break;
	case AppEnvironment.MOCK:
		applicationId = 'b08b01ab-fe0e-460a-8b38-f1c03c75fa88';
		applicationScopeUserImpersonation = 'https://CatCoverage.secureleader.co/catcoverageapplicationdemo/user_impersonation';
		catcoverageDomain = 'http://localhost:62441';
		enableAuthenticationLogging = true;
		googleAnalyticsId = 'UA-24548396-4';
		logoImageSource.logo = '/src/Assets/Images/logo-demo.png';
		publicPagesBaseUrl = 'https://www.catcoverage.com';
		redirectUri = 'http://localhost:3001/CAT';
		break;
	case AppEnvironment.PROD:
		apiDomain = 'https://app-api.catcoverage.com';
		applicationId = 'c14e4895-8fad-4d00-907b-752d9eef38f4';
		applicationScopeUserImpersonation = 'https://CatCoverage.secureleader.co/catcoverageapplication/user_impersonation';
		catcoverageDomain = 'https://portal.catcoverage.com';
		enableAuthenticationLogging = false;
		googleAnalyticsId = 'UA-24548396-1';
		logoImageSource.logo = '/src/Assets/Images/logo.png';
		publicPagesBaseUrl = 'https://www.catcoverage.com';
		redirectUri = 'https://appv2.catcoverage.com/CAT';
		break;
	case AppEnvironment.CROSS_BROWSER:
		apiDomain = 'https://localhost:44327';
		applicationId = 'b08b01ab-fe0e-460a-8b38-f1c03c75fa88';
		applicationScopeUserImpersonation = 'https://CatCoverage.secureleader.co/catcoverageapplicationdemo/user_impersonation';
		catcoverageDomain = 'http://localhost:62441';
		enableAuthenticationLogging = true;
		googleAnalyticsId = 'UA-24548396-4';
		logoImageSource.logo = '/src/Assets/Images/logo-demo.png';
		publicPagesBaseUrl = 'https://www.catcoverage.com';
		redirectUri = 'https://10.0.0.196:3001/CAT';
		break;
	case AppEnvironment.DEV:
	default:
		apiDomain = 'https://localhost:44327';
		applicationId = 'b08b01ab-fe0e-460a-8b38-f1c03c75fa88';
		applicationScopeUserImpersonation = 'https://CatCoverage.secureleader.co/catcoverageapplicationdemo/user_impersonation';
		catcoverageDomain = 'http://localhost:62441';
		enableAuthenticationLogging = true;
		googleAnalyticsId = 'UA-24548396-4';
		logoImageSource.logo = '/src/Assets/Images/logo-demo.png';
		publicPagesBaseUrl = 'https://www.catcoverage.com';
		redirectUri = 'http://localhost:3001/CAT';
}

let postLogoutRedirectUri: string = `${catcoverageDomain}/login.aspx?action=logout&appV2LoggedOut={0}&returnToUrl={1}`;

let catcoverage_uw_pages: { [key: string]: string } = {}
catcoverage_uw_pages[BroadLineOfBusiness.PERSONAL] = `${catcoverageDomain}/underwriterReview_res.aspx?quoteid={0}`;
catcoverage_uw_pages[BroadLineOfBusiness.COMMERCIAL] = `${catcoverageDomain}/all_comm_application.aspx?quoteID={0}`;

let catcoverageLoginUrl: string = `${catcoverageDomain}/LogIn.aspx`;
let catcoverageHomeLoggedOutUrl: string = catcoverageDomain;
let catcoverageHomeLoggedInUrl: string = `${catcoverageDomain}/home.aspx`;
let catcoverageDigitalSignaturesUrl: string = `${catcoverageDomain}/digital_signatures.aspx?policy={0}`;

let rootUrl: string = '/CAT';
let securedUrl: string = '/Secured'
let publicUrl: string = '/Public';
let thirdPartyAuthUrl: string = '/ThirdPartyAuth';
let logoutUrl: string = '/Logout/:appV2LoggedOut/:returnToUrl?';
let adminUrl: string = '/Admin';
let newBusinessApplicationRerouteUrl: string = '/NewBusinessReroute';
let newBusinessApplicationPreliminaryUrl: string = '/Preliminary';
let newBusinessApplicationUrl: string = '/Quote';
let signupUrl: string = '/Signup';
let claimsUrl: string = '/Claims';
let policyUrl: string = '/Policy';
let policyViewPreliminaryUrl: string = '/PolicyViewPreliminary';
let policyViewUrl: string = '/PolicyView';
let policyPacketUrl: string = '/PolicyPacket';
let endorsementPreliminaryUrl: string = '/EndorsementPreliminary';
let endorsementUrl: string = '/Endorsement';

let cacheLocation: BrowserCacheLocation = BrowserCacheLocation.LocalStorage;

let newBusinessApplicationWorkflowTargetRedirects: {
	key: number;
	id: number;
	redirectUrl: string;
}[] = []

export default {
	mode: mode,
	application_api_domain: apiDomain,
	sso_config: {
		instanceUri: 'https://secureleader.b2clogin.com/tfp/',
		tenant: 'secureleader.onmicrosoft.com',
		signInPolicy: 'B2C_1_Si2',
		applicationId: applicationId,
		cacheLocation: cacheLocation,
		scopes: ['openid', applicationScopeUserImpersonation],
		redirectUri: redirectUri,
		postLogoutRedirectUri: postLogoutRedirectUri,
		enableAuthenticationLogging: enableAuthenticationLogging,
	},
	google_api_key: 'AIzaSyDXFBDiTNdP-y7qCunCX31Lt_a8yrCeALI',
	google_analytics_id: googleAnalyticsId,
	google_tag_manager_id: 'GTM-KBK39Z',
	themeConfig: ThemeConfig,
	session_expires_in_seconds: 300,
	catcoverage_domain: catcoverageDomain,
	publicpages_baseurl: publicPagesBaseUrl,
	catcoverage_uw_pages: catcoverage_uw_pages,
	catcoverage_login_page: catcoverageLoginUrl,
	catcoverage_home_logged_out_page: catcoverageHomeLoggedOutUrl,
	catcoverage_home_logged_in_page: catcoverageHomeLoggedInUrl,
	catcoverage_policies_pay_page: `${catcoverageDomain}/all_policies_pay.aspx?pid={0}`,
	catcoverage_producers_page: `${catcoverageDomain}/admin_producers.aspx?pid={0}`,
	catcoverage_all_policies_view_page: `${catcoverageDomain}/all_policies_view.aspx?policy={0}`,
	catcoverage_digital_signatures_page: catcoverageDigitalSignaturesUrl,
	document_source: `${catcoverageDomain}/PDF/?{0}`,
	enableWorkFlowTargetSwitch,
	admin_navigation_config: AdminNavigationConfig({
		adminUrl: adminUrl,
		catcoverageDomain: catcoverageDomain,
		rootUrl: rootUrl,
		securedUrl: securedUrl,
	}),
	main_navigation_config: MainNavigationConfig({
		catcoverageDomain,
		catcoverageHomeLoggedOutUrl,
		catcoverageHomeLoggedInUrl,
		publicPagesBaseUrl,
		rootUrl,
		securedUrl,
		publicUrl,
		adminUrl,
		newBusinessApplicationPreliminaryUrl,
		signupUrl,
		claimsUrl,
		policyUrl,
		policyPacketUrl,
	}),
	newBusinessApplicationWorkflowTargetRedirects: newBusinessApplicationWorkflowTargetRedirects,
	legacyNewBusinessApplicationVersionId: 1,
	ofac_ref_link: 'https://www.treasury.gov/about/organizational-structure/offices/Pages/Office-of-Foreign-Assets-Control.aspx',
	fema_flood_zone_layer_url: 'https://hazards.fema.gov/arcgis/rest/services/FIRMette/NFHLREST_FIRMette/MapServer/export?dpi=96&transparent=true&format=png32&layers=show:0,2,4,5,7,8,9,12,13,14,15,18,19,20,21&bbox={0}&bboxSR=4326&imageSR=3857&size=256,256&f=image',
	rootUrl,	
	securedUrl,
	publicUrl,
	thirdPartyAuthUrl,
	logoutUrl,
	adminUrl,
	newBusinessApplicationRerouteUrl,
	newBusinessApplicationPreliminaryUrl,
	newBusinessApplicationUrl,
	signupUrl,
	claimsUrl,
	policyUrl,
	policyViewPreliminaryUrl,
	policyViewUrl,
	policyPacketUrl,
	endorsementPreliminaryUrl,
	endorsementUrl,
	logoImageSource,
};